import { Box, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'

import styles from '../DonationRequestDetails.module.scss'

import { DonationsPerNonprofitTable } from './DonationsPerNonprofitTable/DonationsPerNonprofitTable'
import { useServices } from '@percent/admin-dashboard/containers/service/ServiceContext'
import { DonationsPerNonprofitProps } from './DonationsPerNonprofit.types'
import { Loader } from '@percent/admin-dashboard/common/components'
import { useQueryList } from '@percent/admin-dashboard/common/hooks'
import { QueryStatus } from '@percent/admin-dashboard/common/hooks/useQueryList/useQueryList.types'

const PAGE_SIZE = 10

export function DonationsPerNonprofit({ donationRequestId }: DonationsPerNonprofitProps) {
  const { donationRequestsService } = useServices()
  const { t } = useTranslation()

  const [response, { nextPage, previousPage }] = useQueryList(
    donationRequestsService.getDonationsPerNonprofitEnhancedList(donationRequestId),
    { pageSize: PAGE_SIZE }
  )

  const { queryStatus, totalResults } = response

  return (
    <>
      <Typography variant="h6" className={styles.tableTitle}>
        {t('typography.donationsPerNonprofit')}
      </Typography>

      {queryStatus === QueryStatus.LOADING ? (
        <Box className={styles.loaderBox}>
          <Loader size={5} />
        </Box>
      ) : queryStatus === QueryStatus.ERROR ? (
        <Typography variant="body1" className={styles.error}>
          {response.errorMessage}
        </Typography>
      ) : (
        <DonationsPerNonprofitTable
          totalResults={totalResults}
          data={response.data}
          previousPage={previousPage}
          nextPage={nextPage}
        />
      )}
    </>
  )
}
